// @ts-expect-error incompatibility with node16 resolution
import type {PortableTextBlock} from '@portabletext/types';
import clsx from 'clsx';
import {ReactNode} from 'react';

type Props = {
  children?: ReactNode;
  node: PortableTextBlock;
  right: boolean;
};

export default function Block({children, node}: Props) {
  if (node.style === 'h1') {
    return <h1 className={clsx('font-kormelink text-display')}>{children}</h1>;
  }
  if (node.style === 'h2') {
    return <h2 className={clsx('font-kormelink text-3xl')}>{children}</h2>;
  }
  if (node.style === 'h3') {
    return <h3 className={clsx('mb-2 font-kormelink text-2xl')}>{children}</h3>;
  }
  if (node.style === 'h4') {
    return <h4 className={clsx('mb-2 max-w-2xl text-xl')}>{children}</h4>;
  }
  if (node.style === 'large') {
    return (
      <p
        className={clsx(
          'mb-[.5em] max-w-[40rem] text-lg leading-caption last:mb-0',
        )}
      >
        {children}
      </p>
    );
  }

  // Paragraphs
  return (
    <p className={clsx('mb-[.5em] max-w-[40rem] last:mb-0')}>{children}</p>
  );
}
